module.exports = __webpack_public_path__ + "assets/2f18c5817241dc31c2504cee45cac45f.mp3";